import { Flex, Text } from "@chakra-ui/react";
import { IconCheckeredGarage, IconRepair } from "icons";

const RaceLimit = ({ 
  timesUsed, 
  maximumTimesUsed,
  usageSinceLastRepair,
  nextRepairAt
}: { 
  timesUsed: number, 
  maximumTimesUsed: number,
  usageSinceLastRepair: number,
  nextRepairAt: number
}) => {
  const isRepairNeeded = usageSinceLastRepair >= nextRepairAt;
  return (
    <Flex>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="0.5"
      >
        <Text
          fontSize={{ base: '0.625rem', md: '12.5px' }}
          lineHeight={{ base: '0.625rem', md: '12.5px' }}
          fontWeight={400}
          color="white.80"
          textTransform="uppercase"
          fontFamily="heading"
          textAlign="center"
        >
          Race Limit
        </Text>
        
        <Flex gap="1" alignItems="center" justifyContent="flex-end" w="full">
          <Text
            fontSize={{ base: '0.625rem', md: '0.75rem' }}
            lineHeight={{ base: '0.75rem', md: '0.875rem' }}
            fontWeight={600}
            color={isRepairNeeded ? 'bloodMoon.100' : 'white.80'}
          >
            {timesUsed}
          </Text>
          <Text
            fontSize={{ base: '0.625rem', md: '0.75rem' }}
            lineHeight={{ base: '0.75rem', md: '0.875rem' }}
            fontWeight={600}
            color="white.40"
          >
            /
          </Text>
          <Text
            fontSize={{ base: '0.625rem', md: '0.75rem' }}
            lineHeight={{ base: '0.75rem', md: '0.875rem' }}
            fontWeight={600}
            color="white.40"
          >
            {maximumTimesUsed}
          </Text>
        </Flex>
      </Flex>

      <Flex
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems="center"
        justifyContent="center"
        gap={4}
        zIndex={2}
        width={{ base: '24px', md: '30px' }}
        height={{ base: '20px', md: '26px' }}
        background={isRepairNeeded ? 'linear-gradient(225deg, #FF968D 0%, #E2645A 18%, #D83832 73%, #AD3529 100%)' : 'linear-gradient(225deg, #6DF1E5 0%, #4FC5BA 18%, #26A69A 73%, #1A746B 100%)'}
        borderTopRightRadius="10px"
        borderTopLeftRadius="2px"
        borderBottomLeftRadius="10px"
        borderBottomRightRadius="2px"
        ml="3"
        position="relative"
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          borderTopRightRadius: "10px",
          borderTopLeftRadius: "2px",
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "2px",
          padding: "2px",
          borderWidth: "0px 1.5px 1.5px 1.5px",
          background: "linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
      >
        {isRepairNeeded ? 
        <IconRepair 
          width={{ base: '12px', md: '14px' }}
          height={{ base: '12px', md: '14px' }}
          __css={{
            path: {
              fill: "rgba(0, 0, 0, 0.8)",
            },
          }}
        /> 
        : <IconCheckeredGarage 
            width={{ base: '12px', md: '14px' }}
            height={{ base: '12px', md: '14px' }}
            __css={{
              path: {
                fill: "rgba(0, 0, 0, 0.8)",
              },
            }}
          />
        } 

      </Flex>
    </Flex>
  )
}

export default RaceLimit;